import axios from 'axios'
import React from 'react'
import { apiUrl } from './config'

const ReportApi = {
    getReportDownload: async (body) =>{
        return axios.post(`${apiUrl}/meeting-report` , body)

    }
}

export default ReportApi